import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const CURRENT_PLAN_BILLING_SCHEMA = Object.freeze({
  FULL_PRICE: 0,
  CURRENCY_CODE: '',
});
const RECORD = generateSchema(CURRENT_PLAN_BILLING_SCHEMA);
const KEYS: any = generateKeys(CURRENT_PLAN_BILLING_SCHEMA);

export class CurrentPlanBilling extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get fullPrice(): number {
    return this.get(KEYS.FULL_PRICE);
  }

  get currencyCode(): string {
    return this.get(KEYS.CURRENCY_CODE);
  }
}
